import { render, staticRenderFns } from "./TasksTaskHandlerSidebar.vue?vue&type=template&id=41d3c78f&scoped=true&"
import script from "./TasksTaskHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./TasksTaskHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TasksTaskHandlerSidebar.vue?vue&type=style&index=0&id=41d3c78f&prod&lang=scss&"
import style1 from "./TasksTaskHandlerSidebar.vue?vue&type=style&index=1&id=41d3c78f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d3c78f",
  null
  
)

export default component.exports